import { Route, Routes } from "react-router-dom";
import { PublicRoutes } from "./routes";
import { AuthRoutesValidator, PrivatePlannerRoutes, PrivateUserRoutes } from "./PrivateRoutes";

export const AppRouter = () => {
  return (
    <Routes>
      {/* Usuarios regulares y ruta por defecto */}
      <Route path="/home" element={<PublicRoutes />} />

      {/* Login y Registro */}
      <Route path="/auth/*" element={<AuthRoutesValidator />} />

      {/* Cuenta y historial de compra */}
      <Route path="/account/*" element={<PrivateUserRoutes />} />

      <Route path="/planner/*" element={<PrivatePlannerRoutes />} />

      {/* Ruta por defecto */}
      <Route path="*" element={<PublicRoutes />} />
    </Routes>
  );
};
